import React, { useState } from "react";
import Modal from "../Elements/Modal/Modal";
import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";
import ErrorMessage from "../Elements/ErrorMessage/ErrorMessage";
import SuccessMessage from "../Elements/SuccessMessage/SuccessMessage";
import { deletePromocode } from "../../services/VoucherService";
import "./AdminModalForm.css";

// Admin modal for deleting a single promocode
const AdminDeletePromocodeModal = ({ isOpen, onClose, promocode, onDeleted }) => {
  // Local UI state
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Do not render if modal is closed or promocode is missing
  if (!isOpen || !promocode) return null;

  // Handle delete confirmation action
  const handleSubmit = async () => {
    setError("");
    setSuccess("");

    try {
      setLoading(true);

      await deletePromocode(promocode.code);

      setSuccess("Promocode deleted successfully.");
      setTimeout(() => {
        onDeleted?.();
        onClose();
      }, 1000);
    } catch (err) {
      setError(err.message || "Failed to delete promocode.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={loading ? () => {} : onClose}
      title="Delete Promocode"
      actions={
        <>
          <SecondButton onClick={onClose} disabled={loading}>
            Cancel
          </SecondButton>
          <MainButton onClick={handleSubmit} disabled={loading}>
            {loading ? "Deleting..." : "Delete"}
          </MainButton>
        </>
      }
    >
      {/* Promocode deletion confirmation content */}
      <div className="admin-modal-form">
        <p>
          Are you sure you want to delete this promocode?
          <br />
          <strong>{promocode.code}</strong>
        </p>

        <p>
          Type: <strong>{promocode.type}</strong>
        </p>

        <p>This action cannot be undone.</p>

        {/* Error message */}
        {error && (
          <div className="admin-modal-error-wrapper">
            <ErrorMessage message={error} onClose={() => setError("")} />
          </div>
        )}

        {/* Success message */}
        {success && (
          <div className="admin-modal-success-wrapper">
            <SuccessMessage message={success} onClose={() => setSuccess("")} />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AdminDeletePromocodeModal;
